import { Box, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, Divider } from '@chakra-ui/react';
import Icon from '@legacy-vfuk/core-icon';
import { tooltipBoxStyles, tooltipContentStyles } from '../BundleSecondaryOption/BundleSecondaryOption.styles';
import ContentfulRichText from '@uk-source-web/contentful-rich-text';
import { RichText } from '@/types/Product.types';
import { ITenantPortingTooltip, TenantPortingTooltip } from './TenantPortingTooltip';
import { isEnabled } from '../../../../../utils/flags';

interface ICustomTooltip {
  tooltipText: RichText;
  tooltipExtraDetails?: Omit<ITenantPortingTooltip, 'tooltipText'>;
}

const TooltipWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Popover placement="bottom-end">
      <PopoverTrigger>
        <Box {...tooltipBoxStyles}>
          <Icon name="info-circle" group="system" />
        </Box>
      </PopoverTrigger>
      <PopoverContent backgroundColor="#F4F4F4">{children}</PopoverContent>
    </Popover>
  );
};

const DefaultTooltip = ({ tooltipText }: ICustomTooltip) => {
  return (
    <>
      <PopoverArrow />
      <PopoverBody {...tooltipContentStyles}>
        <ContentfulRichText document={JSON.parse(tooltipText.raw)} />
      </PopoverBody>
    </>
  );
};

export const CustomTooltip = ({ tooltipText, tooltipExtraDetails }: ICustomTooltip) => {
  if (isEnabled('tenantPorting')) {
    return (
      <TooltipWrapper>
        <TenantPortingTooltip tooltipText={tooltipText} {...tooltipExtraDetails} />
      </TooltipWrapper>
    );
  }

  return (
    <TooltipWrapper>
      <DefaultTooltip tooltipText={tooltipText} />
    </TooltipWrapper>
  );
};
